/* eslint-disable class-methods-use-this */
import { runInAction, makeAutoObservable, toJS } from 'mobx';
import { getSeekerLeads } from '../../apiclient/resources/seeker';

export default class SeekerMessageStore {
  limit = 10;

  offset = 0;

  paging = {};

  leads = [];

  loading = 'loading';

  sorted = { value: 'last_activity' };

  constructor() {
    makeAutoObservable(this);
  }

  getSelectedSort() {
    return toJS(this.sorted);
  }

  getLeads(isMobile) {
    this.loading = 'loading';
    if (isMobile) {
      if (this.paging.total !== undefined && this.paging.total > this.offset) {
        this.offset += this.limit;
      }
    }
    getSeekerLeads(this.limit, this.offset, this.sorted.value, isMobile).then(({ error, data }) => {
      runInAction(() => {
        if (!error) {
          this.leads = data.result;
          this.paging = data.paging;
          this.loading = 'loaded';
        } else {
          this.loading = 'error';
          this.leads = [];
          this.offset = 0;
        }
      });
    });
  }

  setParams(sorted) {
    runInAction(() => {
      this.sorted = sorted;
      this.offset = 0;
      this.leads = [];
    });
  }

  getLeadsJS() {
    return toJS(this.leads);
  }
}
